import React, { useEffect, useState } from "react";

import { Form, Formik } from "formik";
import {
  SimpleGrid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Flex,
  Box,
} from "@chakra-ui/react";
import Swal from "sweetalert2";
import * as Yup from "yup";

import { useAppContext } from "../../../../../../Context/MessageContextProvider";
import { CustomButton } from "../../../../../components/CustomButton";
import VaraService from "../../../../../../main/services/VaraService";
import RadioGroupTable from "../../../../../components/RadioGroupTable";
import FiltersRadioGroupTable from "../../../../../components/FiltersRadioGroupTable";
import LoadingSpinner from "../../../../../components/LoadingSpinner";
import { hasFormChanged } from "../../../../../utils/hasFormChanged";
import CriancaService from "../../../../../../main/services/CriancaService";
import { CustomTextArea } from "../../../../../components/CustomTextArea";
import SemRegistros from "../../../../../components/SemRegistros";

const schema = Yup.object().shape({
  justificativaVara: Yup.string().required("Este campo é obrigatório!").trim(),
});

const EditarVaraInfanciaModal = ({
  isOpen,
  onOpen,
  onClose,
  dataVoluntaria,
  columnsVaraInfanciaModal,
  idCrianca,
  fetchAtribuicao,
}) => {
  const {
    cadastrarProcessosProcedimentos,
    setCadastrarProcessosProcedimentos,
  } = useAppContext();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [initialValues, setInitialValues] = useState({
    idOrgao: "",
    justificativaVara: "",
  });
  const [isTextareaFocused, setIsTextareaFocused] = useState(false);

  useEffect(() => {
    if (isOpen === true) {
      VaraService.getVaras()
        .then((res) => {
          setLoading(false);
          setData(res.data);
        })
        .catch((error) => console.log(error));
    }
  }, [isOpen]);

  const backAlert = () => {
    if (cadastrarProcessosProcedimentos) {
      Swal.fire({
        title: "Tem certeza que deseja cancelar?",
        text: "As informações serão perdidas.",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          onClose();
          setCadastrarProcessosProcedimentos(false);
        }
      });
    } else {
      onClose();
    }
  };

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const { justificativaVara, idOrgao } = values;

      const valuesToSend = {
        idOrgao: idOrgao ? Number(idOrgao) : null,
        justificativa: justificativaVara ? justificativaVara?.trim() : "",
      };

      editarVaraInfancia(Number(idCrianca), valuesToSend);

      actions.setSubmitting(false);
    }, 200);
  };

  const editarVaraInfancia = async (id, valuesToSend) => {
    try {
      await CriancaService.editarVaraInfancia(id, valuesToSend);
      Swal.fire({
        title: "Sucesso!",
        text: "Registro atualizado com sucesso!",
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#169499",
      }).then((result) => {});
      onClose();
      fetchAtribuicao();
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Atenção!",
        text: error.response.data.message ? error.response.data.message : "",
        icon: "warning",
        confirmButtonText: "Fechar",
        confirmButtonColor: "#169499",
      });
    }
  };

  useEffect(() => {
    if (dataVoluntaria) {
      setInitialValues({
        idOrgao: dataVoluntaria[0]?.id.toString(),
        justificativaVara: dataVoluntaria[0]?.justificativa
          ? dataVoluntaria[0]?.justificativa.toString()
          : "",
      });
    }
  }, [dataVoluntaria]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        size="6xl"
        scrollBehavior={"inside"}
      >
        <ModalOverlay />
        <ModalContent
          p={{ base: "15px", md: "25px" }}
          w={{ base: "100%", lg: "70%" }}
          bgColor="#FFF"
        >
          <ModalHeader
            p="0px"
            fontWeight={700}
            fontSize="14px"
            lineHeight="19.6px"
            color="#169499"
          >
            EDITAR VARA DA INFÂNCIA
          </ModalHeader>
          <ModalBody p="0px" mt="25px">
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(props) => (
                <>
                  <FiltersRadioGroupTable
                    situacao={true}
                    setData={setData}
                    setLoading={setLoading}
                    entidade="vara"
                  />

                  <Form>
                    {setCadastrarProcessosProcedimentos(
                      hasFormChanged(initialValues, props.values)
                    )}
                    {!loading ? (
                      <>
                        {!!data && data?.length > 0 ? (
                          <RadioGroupTable
                            data={data}
                            columns={columnsVaraInfanciaModal}
                            edit={true}
                          />
                        ) : (
                          <Box mt="4">
                            <SemRegistros buttonVisible={true} half />
                          </Box>
                        )}
                      </>
                    ) : (
                      <Box mt="4">
                        <LoadingSpinner loading={loading} />
                      </Box>
                    )}

                    <CustomTextArea
                      fieldName={"justificativaVara"}
                      label={"Justificativa*"}
                      placeholder={"Informe a Justificativa"}
                      setIsTextareaFocused={setIsTextareaFocused}
                      maxLength={255}
                      isTextareaFocused={isTextareaFocused}
                    />

                    <Flex justifyContent="end">
                      <SimpleGrid
                        mt="25px"
                        columns={2}
                        spacing="15px"
                        w={{ base: "100%", lg: "40%" }}
                      >
                        <CustomButton onClick={backAlert} label="Cancelar" />
                        <CustomButton
                          type="submit"
                          translate="no"
                          isDisabled={loading}
                          isLoading={props.isSubmitting}
                          label="Salvar"
                        />
                      </SimpleGrid>
                    </Flex>
                  </Form>
                </>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default EditarVaraInfanciaModal;
